module.exports = __webpack_public_path__ + "media/Mother-in-law.c81fdafc.mp3";